import { type CreateLogbookRecordInput } from '../../API';
import { getDbSyncer } from '../LocalDB/DbSyncer';
import { getDb } from '../LocalDB/LocalDB';
import { type WithId } from '../LocalDB/types';

export async function getLogbookRecordsByLegId(legId: string): Promise<Array<CreateLogbookRecordInput & WithId>> {
    return getDb().logbookRecords.where({ legId }).toArray();
}

export async function putLogbookRecord(record: CreateLogbookRecordInput & WithId) {
    const db = getDb();
    await Promise.all([db.logbookRecords.put(record), getDbSyncer().markToSync(db.logbookRecords, record.id)]);
}
